
import firebase from "firebase/app";
import { findSchoolByNameOrDocId } from "@/api/school";
import MTextField from "@/components/form/MTextField.vue";
import MButton from "@/components/MButton.vue";
import { School } from "@/entities/school";
import store from "@/store";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MButton,
    MTextField
  }
})
export default class HandleUndeletedUser extends Vue {
  name = "";
  schoolDocId = "";
  foundSchools: (School & { ownerName: string })[] = [];
  hasSearched = false;
  expandedSchoolIndex: number | null = null;
  inputValue = "";

  get showNoResultsMessage() {
    return this.hasSearched && this.foundSchools.length === 0;
  }

  toggleExpanded(index: number) {
    this.expandedSchoolIndex =
      this.expandedSchoolIndex === index ? null : index;
    if (this.expandedSchoolIndex !== index) {
      this.inputValue = "";
    }
  }

  async handleUndeletedUser(
    school: School & { ownerName: string },
    inputValue: string
  ) {
    if (!school) return;
    if (!inputValue) return;

    const call = firebase
      .app()
      .functions("asia-northeast1")
      .httpsCallable("handle_undeleted_user");

    try {
      store.commit("START_LOADING", "処理中...");

      const res = await call({
        schoolDocId: school.ref.id,
        loginId: inputValue.trim()
      });

      const {
        status = "error",
        successes = [],
        failures = [],
        message = "unknown error"
      } = res.data as {
        status?: string;
        successes?: string[];
        failures?: string[];
        message?: string;
      };

      if (status === "aborted") {
        alert("処理がキャンセルされました。" + "\n" + message);
        return;
      }

      if (status === "done") {
        const _message = `
        処理を実行しました。
        
        【削除した項目】
         ${successes.map(_ => `- ${_}`).join("\n")}

        【削除に失敗したか、もともと削除されいた項目】
         ${failures.map(_ => `- ${_}`).join("\n")}
        `;

        alert(_message);

        return;
      }

      alert("問題が発生しました。" + "\n" + message);
    } catch (e) {
      console.error(e);
      alert(
        "エラーが発生しました。" + "\n" + (e instanceof Error ? e.message : "")
      );
    } finally {
      store.commit("END_LOADING");
    }
  }

  moveToHome() {
    this.$router.push({ name: "home" });
  }

  async searchByName() {
    if (!this.name) return;

    try {
      store.commit("START_LOADING", "検索中...");
      this.foundSchools = await findSchoolByNameOrDocId({ name: this.name });
      this.hasSearched = true;
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
    } finally {
      store.commit("END_LOADING");
    }
  }

  async searchByDocId() {
    if (!this.schoolDocId) return;

    try {
      store.commit("START_LOADING", "検索中...");

      this.foundSchools = await findSchoolByNameOrDocId({
        docId: this.schoolDocId
      });
      this.hasSearched = true;
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
    } finally {
      store.commit("END_LOADING");
    }
  }
}
